import { postRequest } from 'src/lib/api-client'
import { logger } from 'src/lib/logger'

export type EventData = {
  userId?: number
  consumerId?: string
  anonymousId?: string
  sessionId?: string
  eventType: string
  info?: Record<string, any>
}

export const sendEvent = async (eventData: EventData): Promise<void> => {
  try {
    const event = { ...eventData, serviceName: 'web' }
    await postRequest('/events/', event)
  } catch (error) {
    logger.error('Error sending event:', error)
  }
}
